"use client";

import ReduxProvider from "@store/provider";
import UserProvider from "@providers/user";
import PusherProvider from "@providers/pusher";
import {
  KeyboardShortcutsProvider,
  TopNavigationProvider,
} from "skedyul-ui/ui";
import dynamic from "next/dynamic";
import { Toaster } from "sonner";
import type { ReactNode } from "react";
import { LayoutModifiedToastManager } from "@/components/layout/LayoutModifiedToastManager";

// For client-only rendering
type ClientOnlyProps = { children: ReactNode };
const ClientOnly = (props: ClientOnlyProps) => {
  const { children } = props;
  return <>{children}</>;
};

const ClientOnlyWrapper = dynamic(() => Promise.resolve(ClientOnly), {
  ssr: false,
});

interface ClientWrapperProps {
  children: ReactNode;
}

export default function ClientWrapper({ children }: ClientWrapperProps) {
  // Performance instrumentation: Long Task observer (dev only)
  if (process.env.NODE_ENV !== "production" && typeof window !== "undefined") {
    const w = window as Record<string, unknown>;
    if (w.__LT_OBSERVER__ !== true) {
      try {
        w.__LT_OBSERVER__ = true;
      } catch {}
    }
  }
  return (
    <ReduxProvider>
      <UserProvider>
        <PusherProvider>
          <ClientOnlyWrapper>
            <KeyboardShortcutsProvider>
              <TopNavigationProvider>
                {children}
                <LayoutModifiedToastManager />
                <Toaster position="bottom-right" />
              </TopNavigationProvider>
            </KeyboardShortcutsProvider>
          </ClientOnlyWrapper>
        </PusherProvider>
      </UserProvider>
    </ReduxProvider>
  );
}
